'use client';

import { Button } from '@ui/button';

import { ChevronRight } from 'lucide-react';
import { Analytics } from 'modules/site-metrics/send-analytics';
import Link from 'next/link';
import { type ReactElement } from 'react';

import styles from './auth-buttons.module.scss';

export const AuthButtons = (): ReactElement => {
  return (
    <>
      <Button
        id="login-nav"
        variant="ghost"
        className={styles.logIn}
        onClick={Analytics.logInClick}
        asChild
      >
        <Link href="/login">
          Log in
          <ChevronRight width={4} />
        </Link>
      </Button>
      <Button
        id="signup-nav"
        className={styles.signUp}
        onClick={Analytics.signUpClick}
        asChild
      >
        <Link href="/signup">
          Sign up
          <ChevronRight width={4} />
        </Link>
      </Button>
    </>
  );
};
